import React, { Component } from 'react'
import { makeObservable, observable } from 'mobx'
import i18n from 'i18next'
import * as R from 'ramda'
import { observer } from 'mobx-react'

import Select from '../form/Select'
import Input from '../form/Input'
import Button from '../../UniformComponents/Button'
import PanelAccordion from '../../UniformComponents/PanelAccordion'

@observer
class QuotaSkipLogic extends Component {
    @observable hasRules = false

    targetPage = ''

    @observable pageId

    @observable quotaOperator

    @observable quota

    skipLogic

    quotaOperators = [
        {
            value: 'Gt',
            label: 'Has more than',
        },
        {
            value: 'Lt',
            label: 'Has less than',
        },
    ]

    constructor() {
        super()
        makeObservable(this)
    }

    componentWillMount() {
        this.initState()
    }

    componentWillUnmount() {
        this.skipLogic = undefined
    }

    getTriggerLens = () => {
        const { store } = this.props
        const { skipLogicConfig } = store
        let lens
        if (skipLogicConfig.type === 'page') {
            lens = R.lensPath(['triggerGroups', 0, 'children', 0, 'triggers'])
        } else {
            lens = R.lensPath(['triggerGroups', 0, 'children', 0, 'triggers', 0, 'condition'])
        }

        return lens
    }

    getActionLens = () => (
        R.lensPath(['action'])
    )

    initState = () => {
        const {
            store,
            pageIndex,
        } = this.props
        const { survey, skipLogicConfig } = store
        const { skipLogic } = survey

        let foundSkipLogic

        const defaultToPage = R.defaultTo({
            value: 'INVALID',
            label: 'INVALID',
        })

        this.page_options = survey.pages.reduce((arr, page, index) => {
            if (index > pageIndex) {
                arr.push({
                    value: page.id,
                    label: `${i18n.t('s_page')}: ${(index + 1)}${(page.title ? (` - ${page.title}`) : '')}`,
                })
            }

            return arr
        }, [])

        if (skipLogicConfig.type === 'page') {
            foundSkipLogic = skipLogic.find((sl) => {
                const triggers = R.defaultTo({})(R.view(this.getTriggerLens())(sl))

                return (
                    sl.action.kind === 'SkipToPage'
                    && triggers[0].condition.kind === 'CurrentPage'
                    && triggers[0].condition.pageId === store.skipLogicConfig.page.id
                )
            })
        } else {
            foundSkipLogic = skipLogic.find((sl) => {
                const trigger = R.defaultTo({})(R.view(this.getTriggerLens())(sl))

                return (
                    sl.action.kind === 'SkipToPage'
                    && trigger.kind === 'QuestionQuota'
                    && trigger.pageQuestionId === skipLogicConfig.question.id
                )
            })
        }
        const sectionSkipLogic = foundSkipLogic
        this.triggerLens = this.getTriggerLens()
        this.actionLens = this.getActionLens()
        const trigger = R.view(this.triggerLens)(sectionSkipLogic)
        let quotaOperator
        let quota

        if (skipLogicConfig.type === 'page') {
            if (!trigger || !trigger[1]) return
            quota = trigger[1].condition.quota
            quotaOperator = this.quotaOperators.find(({ value }) => value === trigger[1].condition.equalityOperator)
        } else {
            if (!trigger) return
            quota = trigger.quota
            quotaOperator = this.quotaOperators.find(({ value }) => value === trigger.equalityOperator)
        }

        const targetPage = defaultToPage(this.page_options.find(({ value }) => (
            value === R.pathOr(-1, ['action', 'pageId'])(sectionSkipLogic)
        )))

        console.log(`init quota -> ${quotaOperator}, ${JSON.stringify(this.quotaOperators)}`)

        this.quota = quota
        this.quotaOperator = quotaOperator
        this.pageId = targetPage

        if (foundSkipLogic) this.hasRules = true
    }

    checkExistingQuotaLogic = () => {
        const { store } = this.props
        const { skipLogicConfig, survey } = store

        if (skipLogicConfig.type === 'page') {
            this.skipLogic = survey.skipLogic.find((sl) => sl.action.kind === 'SkipToPage' && R.pathOr(false, ['triggerGroups', 0, 'children', 0, 'triggers', 1, 'condition', 'kind'], sl) === 'Quota')
        } else {
            this.skipLogic = survey.skipLogic.find((sl) => sl.action.kind === 'SkipToPage' && R.pathOr(false, ['triggerGroups', 0, 'children', 0, 'triggers', 0, 'condition', 'kind'], sl) === 'QuestionQuota')
        }
    }

    updateExistingQuotaLogic = () => {
        const { store } = this.props
        const { skipLogicConfig } = store

        if (skipLogicConfig.type === 'page') {
            this.skipLogic.triggerGroups[0].children[0].triggers[0].condition.pageId = this.pageId.value
            this.skipLogic.triggerGroups[0].children[0].triggers[1].condition.quota = this.quota
            this.skipLogic.triggerGroups[0].children[0].triggers[1].condition.equalityOperator = this.quotaOperator.value
        } else {
            this.skipLogic.triggerGroups[0].children[0].triggers[0].condition.pageId = this.pageId.value
            this.skipLogic.triggerGroups[0].children[0].triggers[0].condition.quota = this.quota
            this.skipLogic.triggerGroups[0].children[0].triggers[0].condition.equalityOperator = this.quotaOperator.value
        }
    }

    createNewQuotaLogic = () => {
        const { store } = this.props
        const { skipLogicConfig, survey } = store

        if (skipLogicConfig.type === 'page') {
            this.skipLogic = survey.newQuotaToPage(
                skipLogicConfig.page.id, this.pageId.value, this.quota, this.quotaOperator.value,
            )
        } else {
            this.skipLogic = survey.newQuestionQuotaToPage(
                skipLogicConfig.question.id, this.pageId.value, this.quota, this.quotaOperator.value,
            )
        }
    }

    removeExistingQuotaLogic = () => {
        const { store } = this.props

        this.skipLogic.remove(store)
        this.hasRules = false
        this.skipLogic = undefined
    }

    save = () => {
        const { store } = this.props
        this.checkExistingQuotaLogic()

        if (this.skipLogic && (R.isNil(this.pageId) || this.quote === '' || R.isNil(this.quotaOperator))) {
            this.removeExistingQuotaLogic()
            return
        }

        if (this.skipLogic) {
            this.updateExistingQuotaLogic()
        } else {
            this.createNewQuotaLogic()
        }

        this.skipLogic.save(store)
        this.hasRules = true
    }

    setQuestionQuotaRouting = (obj) => {
        const { store } = this.props

        if (R.isNil(obj.value)) {
            this.quotaOperator = null
        } else {
            this.pageId = obj
        }

        store.handleUnsavedSkipLogicChanges()
    }

    setQuestionQuotaOperator = (obj) => {
        const { store } = this.props

        if (R.isNil(obj.value)) {
            this.quotaOperator = null
        } else {
            this.quotaOperator = obj
        }

        store.handleUnsavedSkipLogicChanges()
    }

    changeQuestionQuota = (obj) => {
        const { store } = this.props

        const quota = parseInt(obj.value, 10)
        this.quota = quota

        store.handleUnsavedSkipLogicChanges()
    }

    deleteLogic = () => {
        const { store } = this.props
        const { skipLogicConfig, survey } = store

        if (skipLogicConfig.type === 'page') {
            const existingQuotaToPage = survey.skipLogic.find((sl) => sl.action.kind === 'SkipToPage' && R.pathOr(false, ['triggerGroups', 0, 'children', 0, 'triggers', 1, 'condition', 'kind'], sl) === 'Quota')
            existingQuotaToPage.remove(store)
            this.hasRules = false
        } else {
            const existingQuestionQuotaToPage = survey.skipLogic.find((sl) => sl.action.kind === 'SkipToPage' && R.pathOr(false, ['triggerGroups', 0, 'children', 0, 'triggers', 0, 'condition', 'kind'], sl) === 'QuestionQuota')
            existingQuestionQuotaToPage.remove(store)
            this.hasRules = false
        }

        this.pageId = null
        this.quotaOperator = null
        this.quota = ''
    }

    render() {
        const { store } = this.props
        const { skipLogicConfig, survey } = store
        const surveyLocale = { store }
        const ctaText = this.hasRules ? i18n.t('skipLogicModal.editLogic') : i18n.t('skipLogicModal.addLogic')

        return (
            <PanelAccordion
                title={i18n.t('skipLogicModal.quotaSkipLogic')}
                description={i18n.t('skipLogicModal.quotaSkipLogicDescription')}
                ctaLabel={ctaText}
                hasRules={this.hasRules}
            >
                <div className="quota-logic-table">
                    <div className="quota-logic-table-header">
                        {skipLogicConfig.type === 'question'
                            ? <div className={`skip-logic-question-color q_${skipLogicConfig.question.oid}`} />
                            : null}

                        <p>{skipLogicConfig.type === 'page' ? i18n.t('skipLogicModal.quotaTableHeader') : skipLogicConfig.question.question.content.getTitleByLocale('shortTitle', surveyLocale, survey.metadata.defaultLocale)}</p>
                    </div>

                    <React.Fragment>
                        <div className="quota-logic-table-body">
                            <Select
                                label={i18n.t('skipLogicModal.quotaDropdownLabel')}
                                options={this.quotaOperators}
                                value={this.quotaOperator ? this.quotaOperator : null}
                                onBlur={this.setQuestionQuotaOperator}
                                isClearable
                                blurOnClear
                                style={{ width: '100%' }}
                            />

                            <Input
                                type="number"
                                label={i18n.t('skipLogicModal.quotaResponsesLabel')}
                                cssClass="reponses-input"
                                min={0}
                                step={1}
                                value={this.quota ? this.quota : ''}
                                placeholder={i18n.t('form.input.placeholder')}
                                onChange={this.changeQuestionQuota}
                            />

                            <Select
                                label={i18n.t('skipLogicModal.pageRoute')}
                                options={this.page_options}
                                value={this.pageId}
                                onBlur={this.setQuestionQuotaRouting}
                                isClearable
                                blurOnClear
                                style={{ width: '100%' }}
                            />
                        </div>
                    </React.Fragment>
                </div>

                <br />

                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 20 }}>
                    {this.hasRules && (
                        <Button
                            icon="fal fa-circle-xmark"
                            label={i18n.t('skipLogicModal.deleteLogic')}
                            onClick={this.deleteLogic}
                            cssClass="regular error"
                        />
                    )}

                    <Button
                        icon="fal fa-save"
                        label={i18n.t('skipLogicModal.saveLogic')}
                        onClick={this.save}
                        cssClass="regular primary"
                        disabled={R.isNil(this.pageId) || this.quote === '' || R.isNil(this.quotaOperator)}
                    />
                </div>
            </PanelAccordion>
        )
    }
}

export default QuotaSkipLogic
